import { BlipChat } from 'blip-chat-widget';
import apiUserStatus from '@/services/api-verify-user-status';
import getChatBot from '@/services/setup/get-chat-bot';

export const initBlipChat = async (cdTerritory: string, nmTerritory: string, city: string, state: string) => {
  const userLogged = sessionStorage.getItem('userLogged');

  let statusUser = '';
  if (userLogged) {
    const {
      stName: fullName,
      stEmail: email,
      idUser: userIdentity,
      stPassword: userPassword,
      stDocument: cpf,
    } = JSON.parse(userLogged);

    const hasBlipChat = document.getElementById('blip-chat-container');
    if (!hasBlipChat) {
      const setupChatBot = await getChatBot();
      if (setupChatBot) {
        const blipClient = new BlipChat();

        if (process.env.VUE_APP_CLIENT === 'BAYER') {
          const apiResponse = await apiUserStatus();

          if (apiResponse.RequestResult.AgentStatus.Success) {
            statusUser = apiResponse.RequestResult.AgentStatus.Data;
          }
        }

        blipClient.withAppKey(setupChatBot.chatBotKey)
          .withButton({ color: setupChatBot.skinColorHex, icon: '' })
          .withCustomCommonUrl(setupChatBot.chatBotUrl)
          .withAuth({
            authType: BlipChat.DEV_AUTH,
            userIdentity,
            userPassword,
          })
          .withAccount({
            fullName: `${fullName}`,
            email: `${email}`,
            extras: {
              cpf: `${cpf}`,
              agentStatus: `${statusUser}`,
              cdTerritory: `${cdTerritory}`,
              nmTerritory: `${nmTerritory}`,
              city: `${city}`,
              state: `${state}`,
            },
          });

        blipClient.withEventHandler(BlipChat.CREATE_ACCOUNT_EVENT, () => {
          blipClient.sendMessage({
            type: 'application/vnd.lime.chatstate+json',
            content: {
              state: 'starting',
            },
          });
        });

        blipClient.withEventHandler(BlipChat.LOAD_EVENT, () => {
          blipClient.sendMessage({
            type: 'text/plain',
            content: 'olá',
            metadata: {
              cdTerritory: `${cdTerritory}`,
              nmTerritory: `${nmTerritory}`,
              city: `${city}`,
              state: `${state}`,
            },
          });
        });

        blipClient.build();

        window.setTimeout(() => { document.querySelectorAll<HTMLElement>('#blip-chat-open-iframe').forEach((node) => node.click()); }, 3000);
      }
    }
  }

  return null;
};

export default initBlipChat;
